module.exports = __webpack_public_path__ + "img/5_no.09f0ec8e.svg";